import React from "react";
import { CircularProgress } from "@mui/material";

import s from "./styles.module.css";
interface IProps {
  children: React.ReactNode;
  isLoading: boolean;
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  report: any[];
  noResultsMessage?: React.ReactNode;
}

const ContainerWithLoader = ({
  children,
  isLoading,
  report,
  noResultsMessage = "There are no results",
}: IProps): React.ReactElement => {
  if (isLoading) {
    return (
      <div className={s.container}>
        <div className={s.centered}>
          <CircularProgress />
        </div>
      </div>
    );
  }
  return (
    <div className={s.container}>
      {!report.length ? <span className={s.centered}>{noResultsMessage}</span> : children}
    </div>
  );
};

export default ContainerWithLoader;
